export default function generateUUID() {
    // Generate a random 16-byte array
    const cryptoObj = crypto || window.crypto;
    const arr = new Uint8Array(16);
    cryptoObj.getRandomValues(arr);
  
    // Modify bytes to match the UUID v4 standard
    arr[6] = (arr[6] & 0x0f) | 0x40; // Set version to 0100
    arr[8] = (arr[8] & 0x3f) | 0x80; // Set variant to 10
  
    // Convert to hexadecimal format and insert hyphens
    return [...arr].map((b, i) => (b.toString(16).padStart(2, '0')))
      .join('')
      .replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '$1-$2-$3-$4-$5');
}